import type {
	DataSourcePolicy,
	DataSourcePolicyWithText,
} from "@/souhl_admin/gql/__generated__/graphql"

export type StatusCounts = {
	match: number
	diff: number
	unset: number
	error: number
}

export type SalonDatasourceStatus = "match" | "diff" | "unset"

export function getSalonStatus(
	dataSourcePolicy: DataSourcePolicy,
	goalDataSourcePolicy: DataSourcePolicy | null | undefined
): SalonDatasourceStatus {
	if (goalDataSourcePolicy == null) return "unset"
	if (dataSourcePolicy === goalDataSourcePolicy) return "match"
	return "diff"
}

export function getPolicyLabel(
	policy: DataSourcePolicy,
	policyOptions: readonly DataSourcePolicyWithText[]
): string {
	const found = policyOptions.find((opt) => opt.value === policy)
	return found?.label ?? policy
}

/**
 * DataSourcePolicy の文字列から決定論的にユニークな色を生成する。
 * FNV-1a ハッシュで hue (0-360) に変換し、パステル調の背景色と濃い文字色を返す。
 */
export function getPolicyColor(policy: string): {
	backgroundColor: string
	color: string
} {
	// FNV-1a hash (文字数に依存しにくい均一分布)
	let hash = 2166136261
	for (let i = 0; i < policy.length; i++) {
		hash ^= policy.charCodeAt(i)
		hash = Math.imul(hash, 16777619)
	}
	const hue = (hash >>> 0) % 360
	return {
		backgroundColor: `hsl(${hue}, 45%, 94%)`,
		color: `hsl(${hue}, 55%, 35%)`,
	}
}
